import {Type} from 'class-transformer';
import {Manufacturer} from '../manufacturer/manufacturer';

export class CustomField {
    public readonly id!: string;
    public readonly name!: string;

    @Type(() => Manufacturer)
    public readonly manufacturer!: Manufacturer;
}
